module.exports = __webpack_public_path__ + "static/media/top-day.28a34aee.svg";